export default "__VITE_ASSET__BLc0v4Jq__"